/**
 * Abstração de Diálogos
 * Fornece uma forma de acessar o DialogContext via singleton para uso em serviços se necessário.
 * NOTA: O uso preferencial é via hook useDialog() em componentes.
 */

interface DialogService {
  confirm: (message: string, title?: string) => Promise<boolean>;
  prompt: (message: string, defaultValue?: string, title?: string) => Promise<string | null>;
}

let dialogInstance: DialogService | null = null;

export const setDialogInstance = (instance: DialogService) => {
  dialogInstance = instance;
};

export const dialog = {
  confirm: (message: string, title?: string): Promise<boolean> => {
    if (!dialogInstance) {
      // Fallback para window.confirm se o provider ainda não estiver pronto
      return Promise.resolve(window.confirm(message));
    }
    return dialogInstance.confirm(message, title);
  },
  prompt: (message: string, defaultValue?: string, title?: string): Promise<string | null> => {
    if (!dialogInstance) {
      // Fallback para window.prompt se o provider ainda não estiver pronto
      return Promise.resolve(window.prompt(message, defaultValue));
    }
    return dialogInstance.prompt(message, defaultValue, title);
  }
};
